export default __webpack_public_path__ + "static/media/screen1.19381441.png";